import { render, staticRenderFns } from "./AddPartialAd.vue?vue&type=template&id=61a8335f&"
import script from "./AddPartialAd.vue?vue&type=script&lang=js&"
export * from "./AddPartialAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports